import React, {memo} from 'react';
import {ButtonMenu as PepsicoDsButtonMenu} from '@pepsico-ds/ui';
import PropTypes from 'prop-types';

/**
 * ButtonMenu component that renders a Pepsico DS ButtonMenu with configurable options.
 *
 * @param {Object} props - The properties object.
 * @param {Object} props.buttonProps - Props for the trigger button (same as Button component).
 * @param {Array} props.options - Menu items to display.
 * @param {Function} props.onChange - Callback when a menu item is selected.
 * @param {string} [props.menuPosition='bottom-right'] - Position of the dropdown menu.
 * @param {boolean} [props.disabled=false] - Whether the button menu is disabled.
 * @param {boolean} [props.usePortal=false] - Whether to render the menu in a portal.
 * @returns {JSX.Element} The rendered ButtonMenu component.
 */
const ButtonMenu = ({
  buttonProps,
  options,
  onChange,
  menuPosition = 'bottom-right',
  disabled = false,
  usePortal = false,
  value
}) => {
  return (
    <PepsicoDsButtonMenu
      buttonProps={buttonProps}
      options={options}
      onChange={onChange}
      menuPosition={menuPosition}
      disabled={disabled}
      usePortal={usePortal}
      value={value}
    />
  );
};

ButtonMenu.propTypes = {
  buttonProps: PropTypes.object.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  onChange: PropTypes.func,
  menuPosition: PropTypes.oneOf([
    'top-left',
    'top-right',
    'bottom-left',
    'bottom-right'
  ]),
  disabled: PropTypes.bool,
  usePortal: PropTypes.bool,
  value: PropTypes.object
};

export default memo(ButtonMenu);
